import {animatedScrollTo} from '../helpers';

export default class ScrollToTopComponent {
  static CLASSES = {
    SCROLL_TO_TOP: 'scroll-to-top',
    SCROLL_TO_TOP_VISIBLE: 'scroll-to-top--visible',
    SCROLL_TO_BOTTOM: 'scroll-to-bottom',
    SCROLL_TO_BOTTOM_VISIBLE: 'scroll-to-bottom--visible',
    BUTTON_BLUE: 'button--blue',
    BUTTON_BEIGE: 'button--beige',
    FOOTER: 'footer'
  };

  static initAll() {
    new ScrollToTopComponent();
  }

  constructor() {
    this.$scrollToTop = document.querySelector(`.${ScrollToTopComponent.CLASSES.SCROLL_TO_TOP}`);
    this.$scrollToBottom = document.querySelector(
      `.${ScrollToTopComponent.CLASSES.SCROLL_TO_BOTTOM}`
    );

    this.$footer = document.querySelector(`.${ScrollToTopComponent.CLASSES.FOOTER}`);

    this.onResizeWindow = this.onResizeWindow.bind(this);
    this.onScrollWindow = this.onScrollWindow.bind(this);
    this.onClickBottom = this.onClickBottom.bind(this);
    this.onClickTop = this.onClickTop.bind(this);

    this.init();
  }

  init() {
    this.updateVisibility();
    this.updatePosition();
    window.addEventListener('resize', this.onResizeWindow);
    window.addEventListener('scroll', this.onScrollWindow);
    if (this.$scrollToTop) {
      this.$scrollToTop.addEventListener('click', this.onClickTop);
    }
    if (this.$scrollToBottom) {
      this.$scrollToBottom.addEventListener('click', this.onClickBottom);
    }
  }

  destroy() {
    window.removeEventListener('resize', this.onResizeWindow);
    window.removeEventListener('scroll', this.onScrollWindow);
    if (this.$scrollToTop) {
      this.$scrollToTop.removeEventListener('click', this.onClickTop);
    }
    if (this.$scrollToBottom) {
      this.$scrollToBottom.removeEventListener('click', this.onClickBottom);
    }
  }

  onResizeWindow() {
    this.updateVisibility();
    this.updatePosition();
  }

  onScrollWindow() {
    this.updateVisibility();
    this.updatePosition();
  }

  onClickTop(event) {
    event.preventDefault();

    animatedScrollTo({
      y: 0
    });
  }

  onClickBottom(event) {
    event.preventDefault();

    animatedScrollTo({
      y: window.innerHeight
    });
  }

  updateVisibility() {
    if (window.pageYOffset >= 300) {
      if (this.$scrollToTop) {
        this.$scrollToTop.classList.add(ScrollToTopComponent.CLASSES.SCROLL_TO_TOP_VISIBLE);
      }

      if (this.$scrollToBottom) {
        this.$scrollToBottom.classList.remove(
          ScrollToTopComponent.CLASSES.SCROLL_TO_BOTTOM_VISIBLE
        );
      }
    } else {
      if (this.$scrollToTop) {
        this.$scrollToTop.classList.remove(ScrollToTopComponent.CLASSES.SCROLL_TO_TOP_VISIBLE);
      }

      if (this.$scrollToBottom) {
        this.$scrollToBottom.classList.add(ScrollToTopComponent.CLASSES.SCROLL_TO_BOTTOM_VISIBLE);
      }
    }
  }

  updatePosition() {
    let bottom = 0;
    let footerHeight = this.$footer.offsetHeight;

    if (window.pageYOffset + window.innerHeight >= document.body.scrollHeight - footerHeight) {
      bottom =
        footerHeight - (document.body.scrollHeight - window.pageYOffset - window.innerHeight);
    }

    if (this.$scrollToTop) {
      this.$scrollToTop.style.bottom = `${bottom}px`;
    }

    if (this.$scrollToBottom) {
      this.$scrollToBottom.style.bottom = `${bottom}px`;
    }
  }
}
